import { domAnimation, m } from 'framer-motion';
import type { AffiliateStockListing, CapiProductPage } from 'types/capi/pdp';

import FramerMotion from '~/components/FramerMotion';
import ProductNotificationButton from '~/components/ProductNotificationButton';
import useIsOutOfView from '~/hooks/useIsOutOfView';
import usePageData from '~/hooks/usePageData';
import useRegion from '~/hooks/useRegion';
import useUser from '~/hooks/useUser';

import Buttons from '../../components/Buttons';

type Props = {
  showWhileHiddenRef: React.RefObject<HTMLDivElement>;
  stockListing: AffiliateStockListing;
};

const StickyCta = ({ stockListing, showWhileHiddenRef }: Props) => {
  const product = usePageData<CapiProductPage>();
  const region = useRegion();
  const user = useUser();

  const showSticky = useIsOutOfView(showWhileHiddenRef, '-50px 0px 0px 0px');

  return (
    <FramerMotion feature={domAnimation}>
      <m.div
        initial={false}
        animate={showSticky ? 'visible' : 'hidden'}
        variants={{
          hidden: { opacity: 0, y: 100 },
          visible: { opacity: 1, y: 0 }
        }}
        transition={{ duration: 0.25, ease: 'easeInOut' }}
        className="fixed -bottom-0.5 left-0 z-10 flex w-full items-stretch justify-center gap-2 rounded-t-md bg-black py-4 shadow md:hidden"
      >
        <div className="grow">
          {product.allow_user_notifications && (
            <ProductNotificationButton
              product={{
                affiliateName: stockListing.affiliate.name,
                id: product.product_id,
                image: product.gallery[0],
                legacyId: product.legacy_id,
                name: product.name,
                price: product.price,
                stockStatus: product.stock_status
              }}
              className="content-width h-12"
              pagePosition="WTB"
              placement="sticky"
              sticky
              mode="dark"
              buttonStyle="verbose"
            />
          )}
          {region.code !== 'GB' && !user.isLoggedIn && (
            <Buttons.Gated
              pagePosition="Sticky CTA"
              dynamicVariant
              showAfffiliateLogo
            />
          )}
        </div>
      </m.div>
    </FramerMotion>
  );
};

export default StickyCta;
